export const LIFECYCLE_PLATFORM = Object.freeze({
  AZURE_DEVOPS: "azure_devops",
  JIRA: "jira",
});

export const VCS_PLATFORM = Object.freeze({
  GITHUB: "github",
  AZURE_DEVOPS_GIT: "azure_devops_git",
  SERVICENOW: "servicenow",
  BITBUCKET: "bitbucket",
});

export const HISTORY_DEBOUNCE_MS = 300;
export const HISTORY_PAGE_SIZE   = 10;

export const DEFAULT_DROPDOWN_OPTION = { label: "Select...", value: "" };

export const LIFECYCLE_PLATFORM_DROPDOWN_OPTIONS = [
  DEFAULT_DROPDOWN_OPTION,
  { label: "Azure DevOps", value: LIFECYCLE_PLATFORM.AZURE_DEVOPS },
  { label: "Jira Cloud", value: LIFECYCLE_PLATFORM.JIRA },
];

export const VCS_PLATFORM_DROPDOWN_OPTIONS = [
  DEFAULT_DROPDOWN_OPTION,
  { label: "GitHub", value: VCS_PLATFORM.GITHUB },
  { label: "Azure DevOps", value: VCS_PLATFORM.AZURE_DEVOPS_GIT },
  { label: "ServiceNow", value: VCS_PLATFORM.SERVICENOW },
  { label: "Bitbucket Cloud", value: VCS_PLATFORM.BITBUCKET },
];
